/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 30/12/2021
 */

import BaseObject from '@shared/./BaseObject';
import {docsToDataArray} from "@/utils/helpers";
import FilterOptions from "@/core/js/backend/filters/FilterOptions";
import SortOptions from "@/core/js/backend/filters/SortOptions";
import DataFilter from "@/core/js/backend/filters/DataFilter";

export default class Pager extends BaseObject{


	filterOptions: FilterOptions
	sortOptions: SortOptions
	dataFilter: DataFilter

	limit: number = 20

	loadCounter: number = 0
	hasMore: boolean = true;
	clazz;

	ref;
	lastDoc;



	constructor(ref, clazz, limit = 10, resArrayToDataArrayFn) {
		super();
		this.sortOptions = new SortOptions()
		this.filterOptions = new FilterOptions()
		this.limit = limit;
		this.clazz = clazz;
		this.ref = ref
		this.resArrayToDataArrayFn = resArrayToDataArrayFn || docsToDataArray
	}

	setExtraDataFilter(dataFilter){
		this.dataFilter = dataFilter
	}

	addSortOption(field, direction){
		this.sortOptions.add(field, direction)
		return this;
	}

	addFilterOption(field, operation, value){
		this.filterOptions.add(field, operation, value)
		return this;
	}

	addFilterOptionArray(field, value){
		this.filterOptions.addArray(field, value)
		return this;
	}


	// indicates if the previous load was initial.
	// "false" means the last operation was "loadMore"
	isInitialLoad(){
		// console.log("Pager.isInitialLoad: this.loadCounter = ", this.loadCounter)
		return this.loadCounter <= 1
	}

	mergeData(dataFull, newData){
		// console.log("Pager.mergeData: newData = ", newData, ", dataFull = ", dataFull, ", this.isInitialLoad() = ", this.isInitialLoad())
		if(this.isInitialLoad()){
			this.removeAllElements(dataFull)
		}
		dataFull.push(...newData)
		return dataFull
	}

	removeAllElements(arr){
		while (arr.length) {
			arr.pop();
		}
	}


	reset(){
		this.filterOptions.reset()
		this.sortOptions.reset()
		this.lastDoc = null
		this.loadCounter = 0
		this.hasMore = true;
		return this
	}

	createQuery(){
		let nextQuery = this.sortOptions.apply(this.ref);
		nextQuery = this.filterOptions.apply(nextQuery)
		console.log("Pager.createQuery: this.dataFilter = ", this.dataFilter)
		if(this.dataFilter){
			nextQuery = this.dataFilter.applyFilters(nextQuery)
		}
		nextQuery = nextQuery.limit(this.limit)
		if(this.lastDoc){
			nextQuery = nextQuery.startAfter(this.lastDoc)
		}
		return nextQuery

	}
	nextOld(callback){
		this.next()
			.then(callback)
	}

	async next(){
		this.loadCounter++
		// console.log("Pager.next: this.loadCounter = ", this.loadCounter)
		if(!this.hasMore){
			return []
		}
		let nextQuery = this.createQuery()
		let res = await nextQuery.get()
		return this.processResult(res)
	}

	processResult(res){
		if(res.docs.length < this.limit){
			this.hasMore = false;
		} else {
			this.lastDoc = res.docs[res.docs.length-1];
		}
		let lastChunk = this.resArrayToDataArrayFn(res, this.clazz);
		// console.log("Pager: lastChunk = ", lastChunk)
		return lastChunk
	}


}



